/*------------------------------------*\
    MODULES
\*------------------------------------*/
window.$ = window.jQuery = require('jquery');
import Masonry from 'masonry-layout';
const fancybox = require('@fancyapps/fancybox');

/*------------------------------------*\
    GALLERY MODULE
\*------------------------------------*/
class Gallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

    }

    init() {
        let self = this;

        self.galleryLayout();
        self.fancyBox();
    }

    galleryLayout() {
        let self = this;
        const gallery = self.elem.querySelector('.gallery');

        $(window).load(function () {
            const msnry = new Masonry(gallery, {
                itemSelector: '.gallery__item',
                columnWidth: '.gallery__sizer',
                percentPosition: true
            });
        })

    }

    fancyBox() {
        let self = this;

        $('[data-fancybox="gallery"]').fancybox({
            arrows: true,
            infobar: false,
            caption: function (instance, item) {
                return $(this).find('figcaption').html();
            },
            buttons: [
                "close"
            ],
        });
    }



}

export default Gallery;